// extracted by mini-css-extract-plugin
module.exports = {"progress":"Progress_progress__2tNSp","progressHeroImg":"Progress_progressHeroImg__1KETo","progressText":"Progress_progressText__2oQ5l"};